<template>
    <div :class="className">
        <div :class="container">
            <div :class="rowName">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script setup>
import { authConf } from '@/components/configs/authConfig';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const className = computed(() => authConf.find(item => item.name === route.name)?.class || '');
const container = computed(() => authConf.find(item => item.name === route.name)?.container || '');
const rowName = computed(() => authConf.find(item => item.name === route.name)?.row || '');

</script>